import SuperFetch from 'library/helpers/superFetch';
import { removeEmptyOrNull } from 'library/helpers/utility';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { devicesActions } from 'reduxStore/devices/slice';
import { Notification } from 'zComponents/atoms';
import { Button, Form, Modal, Steps } from 'zui/Antd';
import { ConditionalTooltipButton } from 'zui/Custom';
import formSteps from './steps';

const { Step } = Steps;

const CreatePermissionModal = ({ children }) => {
	// Hooks
	const dispatch = useDispatch();
	const [stepForm] = Form.useForm();

	// Local State
	const [current, setCurrent] = useState(0);
	const [grantLoading, setGrantLoading] = useState(false);
	const [visible, setVisible] = useState(false);

	const handleCancel = () => {
		// at the last of the function

		// set the current step to 0
		setCurrent(0);

		// reset the form
		stepForm.resetFields();

		// close the modal
		setVisible(false);
	};

	const onFinish = () => {
		const formData = removeEmptyOrNull(stepForm.getFieldsValue(true));

		if (!(formData.devices?.length > 0 || formData.groups?.length > 0)) {
			Notification('error', 'Please select at least one device or group.', '', 'top');
			return;
		}

		// Grant Permission.
		setGrantLoading(true);

		const body = {
			deviceIDs: formData.devices,
			personIDs: formData.people,
			permissionTypeID: 1, // ? setting the permission Type 1: Default for every person
			assetGroupIDs: formData.groups,
			teamIDs: formData.teams
		};
		SuperFetch.post(`/access/grantPermission`, body).then((res) => {
			if (res.statusCode === 200) {
				Notification('success', 'Permission Granted.');
				handleCancel();
				dispatch(devicesActions.loadDevices());
			} else {
				Notification('error', 'Error while granting permission. Please try again.');
			}
			setGrantLoading(false);
		});
	};

	const reset = () => {
		if (current === 0) {
			stepForm.resetFields(['people', 'teams']);
		}
		if (current === 1) {
			stepForm.resetFields(['devices', 'groups']);
		}
	};

	const prev = () => {
		setCurrent(current - 1);
	};

	const next = () => {
		const formValues = stepForm.getFieldsValue(true);
		if (current === 0 && (formValues.people?.length > 0 || formValues.teams?.length > 0)) {
			setCurrent(current + 1);
		} else {
			Notification('error', 'Select People or Teams to continue.', '', 'top');
		}
	};

	return (
		<Fragment>
			<ConditionalTooltipButton buttonText={'Create New Permission'} onClick={() => setVisible(true)}>
				{children}
			</ConditionalTooltipButton>
			<Modal
				width={800}
				title={'Create Permission'}
				open={visible}
				onCancel={handleCancel}
				destroyOnClose={true}
				footer={[
					<Button key='reset' onClick={reset}>
						Reset
					</Button>,
					current > 0 && (
						<Button key='previous' onClick={() => prev()}>
							Previous
						</Button>
					),
					current < formSteps.length - 1 && (
						<Button key='next' type='primary' onClick={() => next()}>
							Next
						</Button>
					),
					current === formSteps.length - 1 && (
						<Button form={stepForm} loading={grantLoading} onClick={onFinish} type='primary'>
							Grant Permission
						</Button>
					)
				]}
			>
				<Form layout='vertical' form={stepForm} id={'createPermissionForm'} autoComplete='off'>
					<Steps responsive current={current}>
						{formSteps.map((item) => (
							<Step key={item.title} title={item.title} />
						))}
					</Steps>

					<div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
						{formSteps[current].content}
					</div>
				</Form>
			</Modal>
		</Fragment>
	);
};

export default CreatePermissionModal;
